import styled from 'styled-components';

export const ScrollContainer = styled.div`
   display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  scrollbar-width: none;
  gap: 10px;
`;

export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.5; 
  font-weight: 500;
  color: #323131;
`;

export const RegulationContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 15px;
  background-color: #FFF;
  border-radius: 10px;
  border: 1px solid #F4F4F5;
  cursor: pointer;
  gap: 8px;
  color: #1C1C1C;
  transition: background-color 0.3s ease, color 0.3s ease, border 0.3s ease;
  &:hover {
    background-color: #1C1C1C;
    border: 1px solid #1C1C1C;
    color: #FFF
  }
`;

export const RegulationTitle = styled.span`
  font-size: 14px;
  color: inherit;
  flex: 1;
`;

export const RegulationButton = styled.div`
  display: flex;
  padding: 5px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  background: #F4F4F5;
`;
